import { IntroReward } from 'store/intro-reward/types';
import { FailureActionPayload } from '../errors/types';
import { createAsyncAction } from 'typesafe-actions';

export const getIntroReward = createAsyncAction(
  'GET_INTRO_REWARD_REQUEST',
  'GET_INTRO_REWARD_SUCCESS',
  'GET_INTRO_REWARD_FAILURE',
)<[undefined, undefined], IntroReward, FailureActionPayload>();
